'use client'

import StepTabs from './stepTabs'

export default StepTabs
